import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, catchError } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;
const level = 4;
@Injectable({
  providedIn: 'root'
})
export class SubcategoryService {

  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService) { }
  createItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/categoryhierarchy`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/${level}`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/categoryhierarchy/update`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  deleteItem(data: any): Observable<any> {
    const obj = { id: data.deleted_id };
    return this.http.post<any>(`${apiurl}/categoryhierarchy/delete`, obj).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGroupOption(): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/option`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getMainCategoryOption(id: string): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/option/${id}`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getCategoryOption(id: string): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/option/${id}`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getMainCategoryItems(param: HttpParams = null): Observable<any> {

    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/2`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/3`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
}
